import * as React from 'react';
import { Label } from '@fluentui/react/lib/Label';
import { Select } from 'formComponents/Select/Select';
import { ValueType } from 'react-select';
import { SelectOption } from 'formComponents/Select/types';
import { useBetreuer, useBetreuerByNr } from 'api/betreuer';
import { MenuPlacement } from 'react-select/src/types';

interface BetreuerByIdProps {
    label: string;
    disabled?: boolean;
    value: number | null;
    renderLabel?: 'label' | 'placeholder' | 'no';
    menuPlacement?: MenuPlacement;
    allowEmpty?: boolean;
    emptyLabel?: string;
    onChange: (newValue: number) => void;
}

export const BetreuerById: React.FC<BetreuerByIdProps> = ({
    label,
    value,
    disabled,
    renderLabel = 'label',
    menuPlacement = 'bottom',
    allowEmpty = false,
    emptyLabel = '',
    onChange,
}) => {
    const betreuer = useBetreuer();
    const betreuerByNr = useBetreuerByNr();

    const options = React.useMemo(() => {
        const o = betreuer
            .filter((b) => b.aktiv && b.name)
            .map((b) => ({
                value: b.nr.toString(),
                label: b.name,
            }));

        if (allowEmpty) {
            o.push({ value: '', label: '' });
        }

        return o;
    }, [betreuer, allowEmpty]);

    return (
        <>
            {renderLabel === 'label' && <Label>{label}</Label>}
            <Select
                name={label}
                isDisabled={disabled}
                isClearable={allowEmpty}
                value={
                    value
                        ? {
                              value: value.toString(),
                              label: betreuerByNr[value]?.name || value.toString(),
                          }
                        : {
                              value: '',
                              label: emptyLabel,
                          }
                }
                options={options}
                menuPlacement={menuPlacement}
                onChange={(option: ValueType<SelectOption, false>): void => {
                    onChange(option?.value ? parseInt(option?.value, 10) || 0 : 0);
                }}
                placeholder={renderLabel === 'placeholder' ? label : ''}
            />
        </>
    );
};
